const drawer = document.getElementById('drawer');

// Keep drawer outside #wrapper so the slide animation does not move the panel
if (drawer && drawer.parentElement !== document.body) {
  document.body.appendChild(drawer);
}

const toggle = document.getElementById('menuToggle');
const closeBtn = document.getElementById('drawerClose');
const overlay = document.getElementById('drawerOverlay');

if (toggle && drawer) {
  toggle.addEventListener('click', () => {
    drawer.classList.add('active');
    document.body.classList.add('no-scroll');
  });
}

if (closeBtn && drawer) {
  closeBtn.addEventListener('click', () => {
    drawer.classList.remove('active');
    document.body.classList.remove('no-scroll');
  });
}

if (overlay && drawer) {
  overlay.addEventListener('click', () => {
    drawer.classList.remove('active');
    document.body.classList.remove('no-scroll');
  });
}
